import { render, staticRenderFns } from "./ReferredTab.htm?vue&type=template&id=2a361dc4&scoped=true&"
import script from "./ReferredTab.ts?vue&type=script&lang=js&"
export * from "./ReferredTab.ts?vue&type=script&lang=js&"
import style0 from "./ReferredTab.scss?vue&type=style&index=0&id=2a361dc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a361dc4",
  null
  
)

export default component.exports